// extracted by mini-css-extract-plugin
export default {"plannedDot":"plannedDot--jt1x2"};